import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshCw = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 2.8877V5.8877H8.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 10.8877V7.8877H3.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.755 5.38773C2.00858 4.67113 2.43957 4.03043 3.00773 3.52544C3.5759 3.02045 4.26273 2.66762 5.00414 2.49986C5.74555 2.33211 6.51738 2.3549 7.2476 2.56612C7.97781 2.77734 8.64263 3.17009 9.18 3.70773L11.5 5.88773M0.5 7.88773L2.82 10.0677C3.35737 10.6054 4.02219 10.9981 4.7524 11.2093C5.48262 11.4206 6.25445 11.4434 6.99586 11.2756C7.73727 11.1079 8.4241 10.755 8.99227 10.25C9.56043 9.74503 9.99142 9.10434 10.245 8.38773",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRefreshCw;
